var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { IsOptional } from "class-validator";
import { BonusCompType, BonusLegalType, BonusTypeMode } from "../../model";
import { safeAssign } from "./safe-assign";
export class BonusTypeOverrideDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeOverrideDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeOverrideDTO.prototype, "subjectId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeOverrideDTO.prototype, "objectId", void 0);
export class BonusTypeDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BonusTypeDTO.prototype, "mode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BonusTypeDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BonusTypeDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BonusTypeDTO.prototype, "weekDays", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BonusTypeDTO.prototype, "holidays", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], BonusTypeDTO.prototype, "intervals", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BonusTypeDTO.prototype, "minDuration", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BonusTypeDTO.prototype, "minDurationPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BonusTypeDTO.prototype, "shiftMustStartBefore", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], BonusTypeDTO.prototype, "taxFree", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeDTO.prototype, "taxFreeUpToRate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], BonusTypeDTO.prototype, "continuedPay", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BonusTypeDTO.prototype, "compType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeDTO.prototype, "maxPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeDTO.prototype, "defaultPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeDTO.prototype, "fixedHourlyRateMax", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeDTO.prototype, "fixedHourlyRateDefault", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeDTO.prototype, "fixedAmountMax", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeDTO.prototype, "fixedAmountDefault", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], BonusTypeDTO.prototype, "overrides", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusTypeDTO.prototype, "order", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], BonusTypeDTO.prototype, "legalType", void 0);
//# sourceMappingURL=bonus-type.dto.js.map